import Navbar from './components/Navbar';
import HeroSection from './components/HeroSection';
import EmotionalHookSection from './components/EmotionalHookSection';
import HowItWorksSection from './components/HowItWorksSection';
import SocialExperienceSection from './components/SocialExperienceSection';
import SendDrinkSection from './components/SendDrinkSection';
import RedemptionSection from './components/RedemptionSection';
import OccasionsSection from './components/OccasionsSection';
import ForBarsSection from './components/ForBarsSection';
import AppShowcaseSection from './components/AppShowcaseSection';
import BrandStatementSection from './components/BrandStatementSection';
import FinalCTASection from './components/FinalCTASection';
import Footer from './components/Footer';

export default function Home() {
  return (
    <div className="relative min-h-screen bg-background-950">
      <Navbar />
      <main>
        <HeroSection />
        <EmotionalHookSection />
        <HowItWorksSection />
        <SocialExperienceSection />
        <SendDrinkSection />
        <RedemptionSection />
        <OccasionsSection />
        <ForBarsSection />
        <AppShowcaseSection />
        <BrandStatementSection />
        <FinalCTASection />
      </main>
      <Footer />
    </div>
  );
}